import {createBackendEditor, referenceActionData} from '../../form/ComponentEditor';
import OperationListEditor from './OperationListEditor';
import {postData, sendRequest} from "../../../utils/request";
import React, {Fragment} from "react";
import {store} from "../../../store";
import {showModal} from "../../../actions";
import isEqual from "lodash-es/isEqual";
import ShopSalesForm from "./Elements/ShopSalesForm";
import Button from "../../form/Button";
import ComponentConfig from "../../form/ComponentConfig";
import get from "../../../utils/get";
import set from "../../../utils/set";
import Icon from "../../form/Icon";
import {
    BarcodeFormatter,
    CurrencyFormatter,
    ProductSelect,
    UpdatedByFormatter,
    UserFormatter
} from "../../../utils/formatters";
import ModalEditor from "../ModalEditor";
import ShippingEditor from "../shippingEditor";
import EventReservationEditor from "../EventReservationEditor";
import connect from "react-redux/es/connect/connect";
import ContentLoader from "../../layout/ContentLoader";
import {PriceView} from "../../classes/Price";

class ShopSalesEditorComponent extends React.Component {

    state = {
        componentEditor: "ShopSales",
        filter: [
            {column: "preset", value: "ShopSales"},
            {column: "fullprice", value: 0, operator: ">"}
        ],
        actionButtons: [],
        availablePaymentProviders: [],
        availableShippingProviders: [],
        actions: true,
        pool: {
            selection: {},
            labelKey: "displayname",
            optionsTemplate: ProductSelect,
            label: false,
            component: "OperationPoolItem",
            storeType: "remote",
            valueKey: "component_id",
            view: ["id","product_id","OperationList_id", "vat", "component_type", "component_id", ...PriceView("saleprice"), "saleprice", ...PriceView("listprice"), "listprice", "instock", "sold", "used"],
            searchFormatter: BarcodeFormatter,
            placeholder: "Vonalkód vagy cím",
            onSourceItemUpdate: (value) => {
                value = {...value};
                value.pickedqty = 1;
                return value;
            }
        },
        total: 0
    };

    promisedSetState = (newState) => {
        return new Promise((resolve) => {
            this.setState(newState, () => {
                resolve()
            });
        });
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.loadProviders();
    }

    onVoucherItemUpdate = (item) => {
        const props = {...this.props};
        const voucher = (props.values.payments || []).find((v) => v.serviceprovider_type === "VoucherPayment");
        let voucherIndex = (props.values.payments || []).findIndex((v) => v.serviceprovider_type === "VoucherPayment");
        let vouchers = JSON.parse(JSON.stringify((voucher || {}).vouchers || []));
        const index = vouchers.findIndex((i) => i.id + "" === "" + item.component_id);
        if (index === -1) {
            vouchers.push({...item, id: item.component_id});
        }
        let oldValue = get(props.values.payments, voucherIndex + ".vouchers");
        if (!isEqual(oldValue, vouchers)) {
            const v = Array.isArray(props.values.payments) ? [...props.values.payments] : (props.values.payments ? {...props.values.payments} : []);
            if (voucherIndex === -1) {
                voucherIndex = v.length;
                v[voucherIndex] = {...(v[voucherIndex] || {}), serviceprovider_type: "VoucherPayment"};
            }
            set(v, voucherIndex + ".vouchers", vouchers);
            if (vouchers.length) {
                let voucherAmount = vouchers.map((voucher) => parseFloat(voucher.amount || voucher.saleprice)).reduce((sum, price) => parseFloat(sum || "0") + parseFloat(price || "0"));
                set(v, voucherIndex + ".amount", voucherAmount);
            } else {
                set(v, voucherIndex + ".amount", 0);
            }
            props.setFieldValue((this.props.name || 'payments'), v);
        }
        return true;
    }

    onItemUpdate = (item) => {
        const props = {...this.props};
        const swap = (props.values.payments || []).find((v) => v.serviceprovider_type === "SwapPayment");
        const swapIndex = (props.values.payments || []).findIndex((v) => v.serviceprovider_type === "SwapPayment");
        let purchaseitems = JSON.parse(JSON.stringify((swap || {}).purchaseitems || []));
        const index = purchaseitems.findIndex((i) => i.id + "" === "" + item.id);
        const qty = Math.min(parseFloat(item.pickable_qty), parseFloat(item.qty || "0"));
        if (index !== -1) {
            purchaseitems[index].qty = qty;
        } else {
            item.qty = Math.min(parseFloat(item.pickable_qty), parseFloat(item.qty || "0"));
            purchaseitems.push(item);
        }
        purchaseitems = purchaseitems.filter((item) => parseFloat(item.qty) > 0);
        let oldValue = get(props.values.payments, swapIndex + ".purchaseitems");
        if (!isEqual(oldValue, purchaseitems)) {
            const v = Array.isArray(props.values.payments) ? [...props.values.payments] : (props.values.payments ? {...props.values.payments} : []);
            set(v, swapIndex + ".purchaseitems", purchaseitems);
            if (purchaseitems.length) {
                set(v, swapIndex + ".amount", purchaseitems.map((item) => parseFloat(item.qty) * parseFloat(item.saleprice)).reduce((sum, price) => parseFloat(sum || "0") + parseFloat(price || "0")));
            } else {
                set(v, swapIndex + ".amount", 0);
            }
            props.setFieldValue((this.props.name || 'payments'), v);
        }
        return true;
    }

    refresh = () => {
        this.op && this.op.picklist && this.op.picklist.target && this.op.picklist.target.refresh();
        this.op && this.op.setState({
            refresh: new Date().getTime()
        });
    }

    getPrices = () => {
        const total = this.state.total;
        const payments = (this.props.values.payments || []);
        const cost =
                payments.length > 1
            ?
                payments.map((payment) => parseFloat(payment.amount || "0")).reduce((sum, p) => parseFloat(sum || "0") + parseFloat(p || "0"))
            :
                parseFloat((payments[0] || {}).amount || "0")
        ;
        let overpay = payments.map((payment) => {
            if (payment.serviceprovider_type === "VoucherPayment") {
                return parseFloat(payment.amount || "0");
            }
            return 0;
        });
        if (overpay.length > 1) {
            overpay = overpay.reduce((sum, p) => parseFloat(sum || "0") + parseFloat(p || "0"));
        } else {
            overpay = parseFloat(overpay[0] || "0");
        }
        let rounding = payments.map((payment) => {
            if (payment.serviceprovider_type === "Cash") {
                if (Math.abs(total - cost) < 3) {
                    return total - cost;
                }
            }
            return 0;
        });
        if (rounding.length > 1) {
            rounding = rounding.reduce((sum, p) => parseFloat(sum || "0") + parseFloat(p || "0"));
        } else {
            rounding = parseFloat(rounding[0] || "0");
        }
        return {cost: cost - overpay, overpay, total, rounding};
    }

    getProps = () => {
        const props = {
            ...this.props,
            ...this.state,
            ...this.getPrices(),
        };

        if (props.closing) {
            if (Array.isArray(props.closing) && Array.isArray(props.filter)) {
                props.filter = [...props.closing, ...props.filter];
            } else if (Array.isArray(props.closing)) {
                if (props.filter) {
                    props.filter = [...props.closing, props.filter];
                } else {
                    props.filter = [...props.closing];
                }
            } else if (Array.isArray(props.filter)) {
                if (props.closing) {
                    props.filter = [...props.filter, props.closing];
                } else {
                    props.filter = [...props.filter];
                }
            }
            const sortable = true;
            const filterable = true;
            props.columns = {
                "customer": {header: "Vevő", width: 2, renderer: UserFormatter},
                "fullprice": {header: "Érték", width: 2, renderer: CurrencyFormatter},
                "created_by": {header: "Létrehozta", width: 2, renderer: UpdatedByFormatter},
                "created_at": {header: "Létrehozás időpontja", width: 2}
            };
        }

        const notaccepted = props.total === 0 || !(
                (props.overpay >= props.total && props.cost === 0)
            ||
                (props.total === (props.cost + props.rounding) && props.overpay === 0)
            ||
                (props.total === (props.cost + props.rounding) + props.overpay)
        );

        props.formatOperationItems = (operationitems) => {
            const newOperationItems = {...operationitems};
            delete newOperationItems.listfield;
            newOperationItems.orderBy = false;
            newOperationItems.sortBy = [{field: "updated_at", direction: "DESC"},{field: "created_at", direction: "DESC"}];
            newOperationItems.componentConfig = this.props.OperationItemConfig;
            delete newOperationItems.parentid;
            delete newOperationItems.data;
            newOperationItems.component = "OperationItem";
            newOperationItems.filter = [{field: "OperationList_id", value: props.values[props.componentConfig.idfield]}];
            newOperationItems.rowClassName = (rowData) => {
                if (rowData.component_type === "product") {
                    return {"warning color": !parseInt(rowData.instock)};
                }
            };
            newOperationItems.columns = {...newOperationItems.columns};
            Object.keys(newOperationItems.columns).map((column) => {
                newOperationItems.columns[column].sortable = false;
                newOperationItems.columns[column].filterable = false;
                if (column === "discount") {
                    if (newOperationItems.columns[column].columnCss) {
                        const columnCss = newOperationItems.columns[column].columnCss;
                        newOperationItems.columns[column].columnCss = (field, value, rowData, rowDatas) => {
                            if (rowData.component_type === "product") {
                                return {};//columnCss(field, value, rowData, rowDatas); // nem kell a bolti eladásba :'( RIP
                            } else {
                                return {};
                            }
                        };
                    }
                }
                if (newOperationItems.columns[column].renderer) {
                    if (column !== "actions") {
                        const renderer = newOperationItems.columns[column].renderer;
                        newOperationItems.columns[column].renderer = (value, rowData) => {
                            if (rowData.component_type === "product" || ["qty", "pickedqty", "discount"].indexOf(column) !== -1 || column.indexOf("price") !== -1) {
                                return renderer(value, rowData);
                            } else {
                                return value;
                            }
                        }
                    }
                }
                if (newOperationItems.columns[column].editor) {
                    const editor = newOperationItems.columns[column].editor;
                    newOperationItems.columns[column].editor = (parent) => {
                        return (props, value) => {
                            if (props.rowData.component_type === "product") {
                                return editor(parent)(props, value);
                            } else {
                                return false;
                            }
                        }
                    }
                }
                delete newOperationItems.columns.displayname.renderer;
            });
            newOperationItems.view = [...newOperationItems.view, "component_type", "component_id", "id"];
            return newOperationItems;
        }

        props.actionButtons = [
            <Button
                key="4"
                disabled={props.isLoading || !props.values[props.componentConfig.idfield] || notaccepted}
                color={notaccepted ? "danger" : "primary"}
                className="pull-left"
                icon={{lib: "fa", name: "money"}}
                onClick={async (e) => {
                    const values = await referenceActionData(props.values, props.componentConfig);
                    values.autocheckup = true;
                    values.getInvoice = true;
                    await props.processAction(async () => {
                        const response = await postData({
                            action: 'OperationList.doAction',
                            actionname: 'create',
                            data: await referenceActionData(values, this.props.componentConfig)
                        });
                        if (response.success) {
                            await this.props.pristineForm(false);
                            if (response.invoice) {
                                window.open(response.invoice, '_blank');
                            }
                        } else if (!response.success) {
                            if (response.msg) {
                                store.dispatch(showModal({
                                    theme: "danger",
                                    header: "",
                                    text: response.msg
                                }));
                            }
                        }
                        this.loadProviders();
                        return false;
                    });
                }}
            >
                Eladás
            </Button>
        ];
        props.pool.parameters = {};
        if (((props.values || {}).pos || {}).id && (((props.values || {}).pos || {}).location || {}).id) {
            if (((props.values || {}).agent || {}).id) {
                props.pool.parameters.user = ((props.values || {}).agent || {}).id;
            }
            props.pool.parameters.partner = props.values.seller.partner_id;
            props.pool.parameters.OperationList_id = props.values.id;
            props.pool.parameters.seller = props.values.seller.partner_id;
            props.pool.parameters.customer = (props.values.customer || {}).partner_id || props.values.seller.partner_id;
            props.pool.parameters.store = (((props.values || {}).pos || {}).location || {}).id;
        }
        /*if (props.values && props.values.source) {
            props.pool.visible = true;
            props.pool.filter = [{field: "store", value: props.values.source.id}];
        } else {
            props.pool.visible = false;
        }*/
        return props;
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (!isEqual(prevProps.values, this.props.values)) {
            this.loadProviders();
        }
    }

    loadProviders = () => {
        this.availableShippings && this.availableShippings.abort();
        if ((this.props.values.pos || {}).id) {
            this.availableShippings = sendRequest({
                option: "componentlist",
                component: "ShippingServiceProvider",
                filter: [
                    {field: "pos", value: (this.props.values.pos || {}).id}
                ]
            });
            this.availableShippings.then((response) => {
                this.setState({
                    availableShippingProviders: response.items
                });
            });
        } else {
            this.setState({
                availableShippingProviders: []
            });
        }
        this.availablePayments && this.availablePayments.abort();
        if ((this.props.values.pos || {}).id && (this.props.values.shipping || {}).serviceprovider_type) {
            this.availablePayments = sendRequest({
                option: "componentlist",
                component: "PaymentServiceProvider",
                filter: [
                    {field: "pos", value: (this.props.values.pos || {}).id},
                    {field: "shipping", value: (this.props.values.shipping || {}).serviceprovider_type},
                ],
                order: [{expression: "FIELD({{id}}, '" + this.props.paymentConfig.objects.join("', '") + "')"}]
            });
            this.availablePayments.then((response) => {
                this.setState({
                    availablePaymentProviders: response.items
                });
            });
        } else {
            this.setState({
                availablePaymentProviders: []
            });
        }
    }

    setStateField = (field, value) => {
        let oldValue = get(this.state, field);
        if (!isEqual(oldValue, value)) {
            const v = {...this.state};
            set(v, field, value);
            this.setState(v);
        }
    }

    setStateFields = (value) => {
        this.setState(value);
    }

    renderer = (componentProps) => {
        return <ShopSalesForm
            {...componentProps}
            onItemUpdate={this.onItemUpdate}
            onVoucherItemUpdate={this.onVoucherItemUpdate}
            getPrices={this.getPrices}
            setStateField={this.setStateField}
            setStateFields={this.setStateFields}
        />;
    }

    render() {
        const props = this.getProps();
        return <OperationListEditor ref={(op) => this.op = op} {...props} renderer={this.renderer}/>;
    }

}

class ShopSalesEditor extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: !this.props.values[this.props.componentConfig.idfield] && !this.props[this.props.componentConfig.idfield]
        }
        if (!this.props.values[this.props.componentConfig.idfield] && !this.props[this.props.componentConfig.idfield]) {
            this.loadNew();
        }
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (!this.props.values[this.props.componentConfig.idfield] && !this.props[this.props.componentConfig.idfield] && !this.state.loading) {
            this.setState({loading: true}, this.loadNew);
        }
    }

    loadNew = async () => {
        await this.props.pristineForm();
        this.setState({loading: false});
    }

    render() {
        if (!this.props.values[this.props.componentConfig.idfield]) {
            return <ContentLoader/>;
        }
        return <ShopSalesEditorComponent {...this.props}/>;
    }
}

export default connect((state) => {
    return {
        till: state.app.till
    }
})(createBackendEditor({
    componentName: "OperationList",
    WrappedComponent: (props) => {
        return (
            <Fragment>
                <ComponentConfig componentName="OperationItem" componentConfigAs="OperationItemConfig">
                    <ComponentConfig componentName="payment" componentConfigAs="paymentConfig">
                        <ShopSalesEditor {...props}/>
                    </ComponentConfig>
                </ComponentConfig>
                {!!(((props.till || {}).pos || {}).location || {}).id && !props.closing && <Fragment>
                    <ShippingEditor
                        collapsed={true}
                        editor={ModalEditor}
                        listFilter={[
                            {
                                field: "state",
                                value: 2
                            }
                        ]}
                        selection={null}
                        pos={(props.till || {}).pos}
                    />
                    {/*<EventReservationEditor
                        collapsed={true}
                        editor={ModalEditor}
                        selection={null}
                        pos={(props.till || {}).pos}
                    />*/}
                </Fragment>}
            </Fragment>
        );
    },
    editor: "ShopSales",
    dirtyFlag: (values) => {
        return !parseInt(values.saved) && values.id;
    },
    props: {
        saveable: false,
        componentActions: async (action, data, params, componentConfig) => {
            data = await referenceActionData(data, componentConfig);
            params.preset = "ShopSales";
            data = {...data};
            delete data.vouchers;
            delete data.items;
            delete data.created_by;
            delete data.modified_at;
            return {action,data,params};
        }
    }
}));